import {
	IconCoin,
	IconCreditCard,
	IconHelpCircle,
	IconId,
	IconLock,
	IconUser,
	IconVelocimeter,
} from "@consumidor-positivo/aurora";
import { useRedline } from "@libs/redline";
import isDesktop from "@libs/utils/helpers/isDesktop";
import { pageNames } from "@shared/routes/pageNames";
import { useLocation, useNavigate } from "react-router-dom";

export const usePrivatePagesStates = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const { track: trackRedline } = useRedline();

	const handleNavigate = (path: string, title: string) => {
		trackRedline.userTracking.elementClicked({
			elementType: "button/text",
			name: path,
			text: title,
			location: "navbar",
		});
		navigate(path);
	};

	const dataSourceNavbar = [
		{
			name: "Dívidas",
			dropdown: [
				{
					name: "Minhas dívidas",
					onClick: () => handleNavigate(pageNames.debts.path, "Minhas dívidas"),
					active: location.pathname === pageNames.debts.path,
				},
				{
					name: "Meus acordos",
					onClick: () =>
						handleNavigate(pageNames.myAgreements.path, "Meus acordos"),
					active: location.pathname === pageNames.myAgreements.path,
				},
				{
					name: "Dívidas negativadas",
					onClick: () =>
						handleNavigate(pageNames.negativeDebts.path, "Dívidas negativadas"),
					active: location.pathname === pageNames.negativeDebts.path,
				},
			],
		},
		{
			name: "Crédito",
			dropdown: [
				{
					name: "Ofertas",
					onClick: () => handleNavigate(pageNames.offers.path, "Ofertas"),
					active: location.pathname === pageNames.offers.path,
				},
			],
		},
		{
			name: "Score",
			dropdown: [
				{
					name: "Minha pontuação",
					onClick: () =>
						handleNavigate(pageNames.myScore.path, "Minha pontuação"),
					active: location.pathname === pageNames.myScore.path,
				},
			],
		},
		{
			name: "Meu CPF",
			dropdown: [
				{
					name: "Alerta CPF",
					onClick: () => handleNavigate(pageNames.cpfAlert.path, "Alerta CPF"),
					active: location.pathname === pageNames.cpfAlert.path,
				},
				{
					name: "Consultas em meu CPF",
					onClick: () =>
						handleNavigate(pageNames.cpfLookout.path, "Consultas em meu CPF"),
					active: location.pathname === pageNames.cpfLookout.path,
				},
				{
					name: "Cadastro positivo",
					onClick: () =>
						handleNavigate(
							pageNames.billsAndPayments.path,
							"Cadastro positivo",
						),
					active: location.pathname === pageNames.billsAndPayments.path,
				},
			],
		},
	];

	const itemNameDesktop = ["Minha conta", "Alterar senha", "Central de ajuda"];

	const dataSourceNavbarVertical = [
		{
			name: "Dívidas",
			Icon: <IconCoin />,
			dropdown: [
				{
					name: "Minhas dívidas",
					onClick: () => handleNavigate(pageNames.debts.path, "Minhas dívidas"),
					active: location.pathname === pageNames.debts.path,
				},
				{
					name: "Meus acordos",
					onClick: () =>
						handleNavigate(pageNames.myAgreements.path, "Meus acordos"),
					active: location.pathname === pageNames.myAgreements.path,
				},
				{
					name: "Dívidas negativadas",
					onClick: () =>
						handleNavigate(pageNames.negativeDebts.path, "Dívidas negativadas"),
					active: location.pathname === pageNames.negativeDebts.path,
				},
			],
		},
		{
			name: "Crédito",
			Icon: <IconCreditCard />,
			dropdown: [
				{
					name: "Ofertas",
					onClick: () => handleNavigate(pageNames.offers.path, "Ofertas"),
					active: location.pathname === pageNames.offers.path,
				},
			],
		},
		{
			name: "Score",
			Icon: <IconVelocimeter />,
			dropdown: [
				{
					name: "Minha pontuação",
					onClick: () =>
						handleNavigate(pageNames.myScore.path, "Minha pontuação"),
					active: location.pathname === pageNames.myScore.path,
				},
			],
		},
		{
			name: "Meu CPF",
			Icon: <IconId />,
			dropdown: [
				{
					name: "Alerta CPF",
					onClick: () => handleNavigate(pageNames.cpfAlert.path, "Alerta CPF"),
					active: location.pathname === pageNames.cpfAlert.path,
				},
				{
					name: "Consultas em meu CPF",
					onClick: () =>
						handleNavigate(pageNames.cpfLookout.path, "Consultas em meu CPF"),
					active: location.pathname === pageNames.cpfLookout.path,
				},
				{
					name: "Cadastro positivo",
					onClick: () =>
						handleNavigate(
							pageNames.billsAndPayments.path,
							"Cadastro positivo",
						),
					active: location.pathname === pageNames.billsAndPayments.path,
				},
			],
		},
		{
			name: "Minha conta",
			Icon: <IconUser />,
			onClick: () => handleNavigate(pageNames.account.path, "Minha conta"),
			active: location.pathname === pageNames.account.path,
		},
		{
			name: "Alterar senha",
			Icon: <IconLock />,
			onClick: () =>
				handleNavigate(pageNames.updatePasswordACP.path, "Alterar senha"),
			active: location.pathname === pageNames.updatePasswordACP.path,
		},
		{
			name: "Central de ajuda",
			Icon: <IconHelpCircle />,
			onClick: () =>
				window.open("https://www.acordocerto.com.br/central-de-ajuda"),
			active: false,
		},
	].filter((item) =>
		isDesktop() ? itemNameDesktop.includes(item.name) : item,
	);

	return { dataSourceNavbar, dataSourceNavbarVertical };
};
